import { type FC, useRef } from "react";

import { Logos, Tooltip, useTooltip } from "widgets";

interface ProtectedResourceLogoProps {
  className?: string;
  size?: number;
}

const ProtectedResourceLogo: FC<ProtectedResourceLogoProps> = (props) => {
  const triggerRef = useRef(null);
  const tooltipRef = useRef<HTMLDivElement>(null);

  const { triggerProps, arrowProps, tooltipProps, state } = useTooltip(triggerRef, tooltipRef, {
    delay: 300,
    offset: 5,
  });
  return (
    <>
      <img
        src={Logos.SelectorLogo}
        width={props.size ?? 20}
        height={props.size ?? 20}
        className={props.className}
        style={{ borderRadius: 3 }}
        alt={"Provided by Genedata Selector"}
        ref={triggerRef}
        {...triggerProps}
      />
      {state.isOpen && (
        <Tooltip
          domProps={tooltipProps}
          arrowProps={arrowProps}
          ref={tooltipRef}
          content={"Provided by Genedata Selector"}
        />
      )}
    </>
  );
};

export { ProtectedResourceLogo };
